<template>
  <li class="nav-main-item">
    <router-link :to="{ name: route }" class="nav-main-link d-none d-lg-inline-flex">
      <font-awesome-icon :icon="icon" class="nav-main-link-icon"/>
      <span v-text="title" class="nav-main-link-name"></span>
    </router-link>
    <router-link @click.native="toggleSidebar" :to="{ name: route }" class="nav-main-link d-lg-none">
      <font-awesome-icon :icon="icon" class="nav-main-link-icon"/>
      <span v-text="title" class="nav-main-link-name"></span>
    </router-link>
  </li>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  props: ['title', 'icon', 'route'],
  name: 'SidebarLink',
  methods: {
    ...mapMutations([
      'toggleSidebar'
    ])
  }
}
</script>

<style scoped>

</style>
